// Em desenvolvimento as chamadas de API passam pelo proxy do dev-server
// (src/setupProxy.js) para evitar CORS: o ksipay-api nao responde ao preflight
// OPTIONS. O authserver responde CORS direto em dev/local (DevCorsConfig la),
// entao o fluxo PKCE (redirect + troca de code) nunca passa pelo proxy.
const useProxy =
	process.env.NODE_ENV === 'development' && process.env.REACT_APP_DISABLE_PROXY !== 'true'

// Base da API do KSI Pay (context-path /ksipay-api)
export const API_BASE_URL =
	process.env.REACT_APP_API_BASE_URL ||
	(useProxy ? '/ksipay-api' : 'https://gustily-tristful-allene.ngrok-free.dev/ksipay-api')

// Base do authorization server (OAuth2 Authorization Code + PKCE)
export const AUTH_SERVER_URL =
	process.env.REACT_APP_AUTH_SERVER_URL || 'https://dev.auth.ksipay.com.br'

// Client publico PKCE do backoffice (sem client_secret)
export const AUTH_CLIENT_ID = process.env.REACT_APP_AUTH_CLIENT_ID || 'backoffice'

export const AUTH_REDIRECT_URI =
	process.env.REACT_APP_AUTH_REDIRECT_URI || `${window.location.origin}/callback`

export const AUTH_SCOPE =
	process.env.REACT_APP_AUTH_SCOPE ||
	'openid backoffice.account.read backoffice.account.update backoffice.onboarding.read backoffice.onboarding.update backoffice.paying-agent.read backoffice.paying-agent.update backoffice.qitech.test backoffice.bank.create'
